import { isoZ, z } from 'my-zod'

export const cardModel = z.object({
  paymentMethodId: z.string(),
  name: z.string().nullable(),
  brand: z.enum(['amex', 'diners', 'discover', 'jcb', 'mastercard', 'unionpay', 'visa', 'unknown']),
  expMonth: z.number(),
  expYear: z.number(),
  last4: z.string(),
  createdDate: isoZ.instant()
})

export type cardModel = z.infer<typeof cardModel>
